import { z } from 'zod/v4'
import { paginationLinksSchema, paginationMetaSchema } from '@/lib/schema/v2/pagination'
import { zDayJs } from '@/lib/schema/v2/dayjs'
import { ampApiErrorSchema } from '@/lib/schema/v2/amp-api-response'

export const mediaSchema = z.object({
    collection_name: z.string().nullish(),
    content_id: z.string().nullish(),
    conversions_disk: z.string().nullish(),
    created_at: zDayJs.nullish(),
    disk: z.string().nullish(),
    download_url: z.url().nullish(),
    file_name: z.string().nullish(),
    file_size: z.number().nullish(),
    foreign_id: z.string().nullish(),
    is_inline: z.boolean().nullish(),
    mime_type: z.string().nullish(),
    name: z.string().nullish(),
    updated_at: zDayJs.nullish(),
    url: z.url().nullish(),
    uuid: z.uuid().nullish(),
})

export const mediasSchema = z.array(mediaSchema)

export const paginatedMediaResponseSchema = z.object({
    data: mediasSchema.nullish(),
    links: paginationLinksSchema.nullish(),
    meta: paginationMetaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const retrieveMediaResponseSchema = z.object({
    data: mediaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const deleteMediaResponseSchema = z.object({
    data: mediaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export const uploadMediaResponseSchema = z.object({
    data: mediaSchema.nullish(),
    success: z.boolean(),
    error: ampApiErrorSchema.nullish(),
})

export type Media = z.infer<typeof mediaSchema>
export type Medias = z.infer<typeof mediasSchema>
export type PaginatedMediaResponse = z.infer<typeof paginatedMediaResponseSchema>
export type UploadMediaResponse = z.infer<typeof uploadMediaResponseSchema>
export type RetrieveMediaResponse = z.infer<typeof retrieveMediaResponseSchema>
export type DeleteMediaResponse = z.infer<typeof deleteMediaResponseSchema>
